var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8906 2.22266V4.94932C10.8906 5.31859 11.0377 5.67345 11.3001 5.93505C11.5631 6.19693 11.9192 6.34389 12.2904 6.34374H15.4181",
    stroke: "#006CCF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4877 6.63098V13.1277C15.4726 13.5526 15.3736 13.9704 15.1963 14.3569C15.0191 14.7434 14.7671 15.091 14.455 15.3797C13.8238 15.9652 12.9859 16.2761 12.1256 16.2441H6.37049C5.94186 16.2639 5.51353 16.1988 5.11013 16.0526C4.70674 15.9063 4.33623 15.6817 4.01991 15.3918C3.70485 15.1022 3.4504 14.753 3.2713 14.3643C3.0922 13.9757 2.99202 13.5553 2.97656 13.1277V5.3374C2.99162 4.91246 3.09062 4.4947 3.26787 4.10819C3.44511 3.72169 3.6971 3.37408 4.0093 3.0854C4.64048 2.49991 5.47831 2.18899 6.33864 2.221H10.6713C11.3326 2.21888 11.971 2.46357 12.4615 2.90721L14.7059 4.97117C14.9454 5.1775 15.1388 5.43192 15.2734 5.71788C15.4081 6.00385 15.4811 6.31495 15.4877 6.63098Z",
    stroke: "#006CCF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23242 8.09375V13.2301",
    stroke: "#006CCF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5872 10.2561L9.56647 8.23538C9.52274 8.19113 9.47067 8.156 9.41327 8.13202C9.35587 8.10805 9.29428 8.0957 9.23208 8.0957C9.16987 8.0957 9.10828 8.10805 9.05088 8.13202C8.99348 8.156 8.94141 8.19113 8.89769 8.23538L6.87695 10.2569",
    stroke: "#006CCF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.63f34673dc0ceadd7beb96926fca1be7.svg";
export { ForwardRef as ReactComponent };